<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconEyeClosed" clip-path="url(#clip0_4458_47909)">
      <path
        id="Hide"
        d="M9.98637 8.13478L10.8951 7.22603C10.9613 7.47341 11 7.73203 11 8.00003C11 9.65428 9.65425 11 8 11C7.732 11 7.47337 10.9613 7.226 10.8952L8.13475 9.98641C9.12838 9.91866 9.91862 9.12841 9.98637 8.13478ZM15.937 7.75716C15.8755 7.64653 15.0033 6.11816 13.2983 4.82291L12.5706 5.55053C13.8139 6.46466 14.6016 7.53078 14.9117 8.00078C14.3191 8.90316 11.9944 12 8 12C7.401 12 6.844 11.9234 6.31987 11.8012L5.49825 12.6228C6.25363 12.8544 7.08388 13 8 13C13.2341 13 15.8291 8.43703 15.937 8.24291C16.021 8.09178 16.021 7.90828 15.937 7.75716ZM13.8535 2.85353L2.8535 13.8535C2.75587 13.9512 2.62788 14 2.5 14C2.37212 14 2.24413 13.9512 2.1465 13.8535C1.95113 13.6582 1.95113 13.3418 2.1465 13.1465L3.546 11.747C1.2835 10.3812 0.133875 8.37053 0.063 8.24291C-0.021 8.09178 -0.021 7.90816 0.063 7.75703C0.170875 7.56303 2.76587 3.00003 8 3.00003C9.35337 3.00003 10.5256 3.30878 11.5278 3.76528L13.1465 2.14653C13.3419 1.95116 13.6583 1.95116 13.8535 2.14653C14.0488 2.34191 14.0489 2.65828 13.8535 2.85353ZM4.29163 11.0014L5.5575 9.73553C5.20787 9.24503 5 8.64691 5 8.00003C5 6.34578 6.34575 5.00003 8 5.00003C8.64688 5.00003 9.245 5.20791 9.7355 5.55741L10.7591 4.53378C9.95037 4.20991 9.03138 4.00003 8 4.00003C4.00563 4.00003 1.68087 7.09691 1.08837 7.99928C1.46462 8.56953 2.54613 10.013 4.29163 11.0014ZM6.28337 9.00953L9.0095 6.28341C8.71212 6.10778 8.36975 6.00003 8 6.00003C6.89725 6.00003 6 6.89728 6 8.00003C6 8.36978 6.10775 8.71216 6.28337 9.00953Z"
        fill="#8C8C8C"
      />
    </g>
    <defs>
      <clipPath id="clip0_4458_47909">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
